import TuneIcon from "@mui/icons-material/Tune";
import { useState } from "react";
import {
    FormControl,
    IconButton,
    InputLabel,
    MenuItem,
    Popover,
    Select,
} from "@mui/material";
import { StreamQualityType } from "types/StreamQualityType";
import { StreamPlayerModeType } from "types/StreamPlayerModeType";

export interface StreamPopOverProps {
    streamQuality?: StreamQualityType;
    onStreamQualityChanged: (streamQuality: StreamQualityType) => void;

    streamPlayerMode?: StreamPlayerModeType;
    onPlayerModeChanged: (streamPlayerMode: StreamPlayerModeType) => void;
}

export function StreamPopOver(props: StreamPopOverProps) {
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    return (
        <>
            <IconButton
                aria-label="Close"
                onClick={handleClick}
            >
                <TuneIcon />
            </IconButton>
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
            >
                <FormControl
                    sx={{ m: 1, minWidth: 120 }}
                    size="small"
                >
                    <InputLabel>StreamQuality</InputLabel>
                    <Select
                        value={props.streamQuality}
                        label="StreamQuality"
                        onChange={(e) => {
                            props.onStreamQualityChanged(
                                e.target.value as StreamQualityType,
                            );
                            setAnchorEl(null);
                        }}
                    >
                        <MenuItem value={StreamQualityType.High}>High</MenuItem>
                        <MenuItem value={StreamQualityType.Medium}>
                            Medium
                        </MenuItem>
                        <MenuItem value={StreamQualityType.Low}>Low</MenuItem>
                    </Select>
                </FormControl>

                <FormControl
                    sx={{ m: 1, minWidth: 120 }}
                    size="small"
                >
                    <InputLabel>PlayerMode</InputLabel>
                    <Select
                        label="PlayerMode"
                        value={props.streamPlayerMode}
                        onChange={(e) => {
                            props.onPlayerModeChanged(
                                e.target.value as StreamPlayerModeType,
                            );
                            setAnchorEl(null);
                        }}
                    >
                        <MenuItem value={StreamPlayerModeType.LiveStream}>
                            LiveStream (LowLatency)
                        </MenuItem>
                        <MenuItem value={StreamPlayerModeType.Diagnostic}>
                            LiveStream (Non LowLatency)
                        </MenuItem>
                    </Select>
                </FormControl>
            </Popover>
        </>
    );
}
